/* eslint-disable */

import QuestionsServices from "@/services/api/questions.services";
import AccessesServices from "@/services/api/accesses.services";
import questionsServices from "@/services/api/questions.services";
import TeamsService from "@/services/api/teams.services";

const state = {
  reviewQuestions: []
}

const mutations = {
  SET_REVIEW_QUESTIONS(state, payload) {
    state.reviewQuestions = payload
  },

}

const actions = {

    getReviewQuestions({ commit }) {
        return new Promise((resolve, reject) => {
          QuestionsServices.get('getQuestions')
                .then((response) => {
                    commit('SET_REVIEW_QUESTIONS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

  updateQuestions({commit}, payload) {
    return new Promise((resolve, reject) => {
      questionsServices.updateQuestions(
        payload
      )
        .then((response) => {
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

 addSingleQuestion({commit}, payload) {
  return new Promise((resolve, reject) => {
    questionsServices.addSingleQuestion(
      payload.data
    )
      .then((response) => {
        return resolve(response)
      })
      .catch((error) => reject(error))
  })
}

}

const getters = {

    getReviewQuestions: (state) => state.reviewQuestions,





}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
